<template>
  <v-select
    :class="`formulate-input-element formulate-input-element--${context.type}`"
    :data-type="context.type"
    v-model="context.model"
    :options="context.options"
    v-bind="context.attributes"
    :reduce="(x) => x.value"
    label="label"
    :filter="accentInsensitiveFilter"
    @close="onClose"
  />
</template>

<script>
import vSelect from 'vue-select'

/**
 * Normaliza o texto removendo acentos/diacríticos e convertendo para minúsculo,
 * permitindo que a busca ignore a acentuação (ex.: "agua" encontra "Água").
 */
const normalizeText = value =>
  (value || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()

export default {
  components: {
    'v-select': vSelect,
  },
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onClose() {
      this.context.blurHandler()
    },

    /**
     * Filtro do vue-select que ignora acentos na comparação entre o texto
     * digitado e o rótulo das opções.
     */
    accentInsensitiveFilter(options, search) {
      const normalizedSearch = normalizeText(search)

      return options.filter(option => {
        const label = option && typeof option === 'object' ? option.label : option
        return normalizeText(label).indexOf(normalizedSearch) > -1
      })
    },
  },
}
</script>
